import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
import * as CSS from 'csstype';

export const gap = system({
    gap: true,
});

export interface GapProps<ThemeType extends Theme = RequiredTheme> {
    gap?: ResponsiveValue<CSS.Property.Gap, ThemeType> | undefined;
}
